import React from 'react';
import useMetaAccessTokens from 'hooks/useMetaAccessTokens.js';
import { AlertCard } from '@livecommerce/design-system';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import { useFeatureContext } from 'contexts/FeatureContext.jsx';

const MetaRefreshBanner = ({ className }) => {
  const { features } = useFeatureContext();
  const { metaConnectionRefreshNotificationEnabled } = features;
  const { needsRefresh, expiresAt } = useMetaAccessTokens();
  const { t } = useLocalization();

  if (!(metaConnectionRefreshNotificationEnabled && needsRefresh)) return null;

  const needsImmediateRefresh = expiresAt < Date.now() / 1000; // Already expired

  const title = needsImmediateRefresh
    ? t('socialMediaIntegration.metaRefreshNeededTitle')
    : t('socialMediaIntegration.metaRefreshSuggestedTitle');

  const text = needsImmediateRefresh
    ? t('socialMediaIntegration.metaRefreshNeededText')
    : t('socialMediaIntegration.metaRefreshSuggestedText');

  const variant = needsImmediateRefresh ? 'danger' : 'warning';

  return (
    <div className={className}>
      <AlertCard
        variant={variant}
        isCloseButtonShown={false}
        title={title}
      >
        {text}
      </AlertCard>
    </div>
  );
};

export default MetaRefreshBanner;
